import { extractImageFrames, clampTo, withDraft480p } from '../../tools';
import { withDraftTask } from '../../draft';
import type { volcengineModelConfig } from '../types';

export const seedance2BeijingConfigs: Record<string, volcengineModelConfig> = {
    'seedance-2.5-api-beijing': {
        apiKeyEnv: 'VOLCENGINE_API_KEY_BEIJING',
        enableTranslation: false,
        enableAigcMaterialReview: true,
        aigcMaterialChannel: 'beijing',
        buildInput: (params) => {
            const { prompt, imagePrompt, videoUri, videoUris, audioUri, audioUris, aspectRatio, duration, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage, lastImage] = extractImageFrames(imagePrompt);
            const images = (imagePrompt ?? []).filter(Boolean).slice(0, 30);
            // Seedance 2.5：参考视频/音频各自最多 10 个
            const videos = ((videoUris?.length ?? 0) > 0 ? videoUris! : videoUri ? [videoUri] : []).filter(Boolean).slice(0, 10);
            const audios = ((audioUris?.length ?? 0) > 0 ? audioUris! : audioUri ? [audioUri] : []).filter(Boolean).slice(0, 10);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    model: 'ep-20260826182834-kd2dt',
                    content: [
                        {
                            type: "text",
                            text: prompt
                        },
                        {
                            type: "image_url",
                            image_url: { url: firstImage },
                            role: "first_frame"
                        },
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p'] as const, '480p'),
                    ratio: 'adaptive',
                    duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30] as const, 5),
                    // 可选参数
                    generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : true,
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    output_format: clampTo(
                        (typeof providerOptions?.output_format === 'string' ? providerOptions.output_format : 'mp4'),
                        ['mp4', 'mov'] as const,
                        'mp4',
                    ),
                    ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                    // system
                    callback_url: undefined,
                    execution_expires_after: undefined,
                    priority: undefined,
                    return_last_frame: undefined,
                    safety_identifiernew: undefined,
                };
            // 首尾帧模式
            } else if (frameMode === 'first_last') {
                return {
                    model: 'ep-20260826182834-kd2dt',
                    content: [
                        {
                            type: "text",
                            text: prompt
                        },
                        {
                            type: "image_url",
                            image_url: { url: firstImage },
                            role: "first_frame"
                        },
                        {
                            type: "image_url",
                            image_url: { url: lastImage || firstImage },
                            role: "last_frame"
                        },
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p'] as const, '480p'),
                    ratio: 'adaptive',
                    duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30] as const, 5),
                    // 可选参数
                    generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : true,
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    output_format: clampTo(
                        (typeof providerOptions?.output_format === 'string' ? providerOptions.output_format : 'mp4'),
                        ['mp4', 'mov'] as const,
                        'mp4',
                    ),
                    ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                    // system
                    callback_url: undefined,
                    execution_expires_after: undefined,
                    priority: undefined,
                    return_last_frame: undefined,
                    safety_identifiernew: undefined,
                };
            // 参考模式
            } else if (frameMode === 'ref') {
                return {
                    model: 'ep-20260826182834-kd2dt',
                    content: [
                        {
                            type: "text",
                            text: prompt
                        },
                        ...images.map(url => ({
                            type: "image_url",
                            image_url: { "url": url },
                            role: "reference_image"
                        })),
                        ...videos.map(url => ({
                            type: "video_url",
                            video_url: { "url": url },
                            role: "reference_video"
                        })),
                        ...audios.map(url => ({
                            type: "audio_url",
                            audio_url: { "url": url },
                            role: "reference_audio"
                        })),
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30] as const, 5),
                    // 可选参数
                    generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : true,
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    output_format: clampTo(
                        (typeof providerOptions?.output_format === 'string' ? providerOptions.output_format : 'mp4'),
                        ['mp4', 'mov'] as const,
                        'mp4',
                    ),
                    ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                    // system
                    omni_reference_task_type: 'auto',
                    callback_url: undefined,
                    execution_expires_after: undefined,
                    priority: undefined,
                    return_last_frame: undefined,
                    safety_identifiernew: undefined,
                };
            // 文生视频模式
            } else {
                return {
                    model: 'ep-20260826182834-kd2dt',
                    content: [
                        {
                            type: "text",
                            text: prompt,
                        }
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30] as const, 5),
                    // 可选参数
                    generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : true,
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    output_format: clampTo(
                        (typeof providerOptions?.output_format === 'string' ? providerOptions.output_format : 'mp4'),
                        ['mp4', 'mov'] as const,
                        'mp4',
                    ),
                    ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                    // system
                    callback_url: undefined,
                    execution_expires_after: undefined,
                    priority: undefined,
                    return_last_frame: undefined,
                    safety_identifiernew: undefined,
                };
            }
        },
    },
    'seedance-2.5-api-v2v-beijing': {
        apiKeyEnv: 'VOLCENGINE_API_KEY_BEIJING',
        enableTranslation: false,
        enableAigcMaterialReview: true,
        aigcMaterialChannel: 'beijing',
        buildInput: (params) => {
            const { prompt, imagePrompt, videoUri, audioUri, audioUris, quality, providerOptions } = params;
            const images = (imagePrompt ?? []).filter(Boolean).slice(0, 30);
            const audios = ((audioUris?.length ?? 0) > 0 ? audioUris! : audioUri ? [audioUri] : []).filter(Boolean).slice(0, 10);
            // 视频编辑模式
            return {
                model: 'ep-20260826182834-kd2dt',
                content: [
                    {
                        type: "text",
                        text: prompt
                    },
                    {
                        type: "video_url",
                        video_url: { url: videoUri },
                        role: "reference_video"
                    },
                    ...images.map(url => ({
                        type: "image_url",
                        image_url: { url },
                        role: "reference_image"
                    })),
                    ...audios.map(url => ({
                        type: "audio_url",
                        audio_url: { url },
                        role: "reference_audio"
                    })),
                ],
                resolution: clampTo(quality || '480p', ['480p', '720p', '1080p'] as const, '480p'),
                ratio: 'adaptive',
                duration: -1,
                // 可选参数
                generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : true,
                watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                output_format: clampTo(
                    (typeof providerOptions?.output_format === 'string' ? providerOptions.output_format : 'mp4'),
                    ['mp4', 'mov'] as const,
                    'mp4',
                ),
                ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                // system
                omni_reference_task_type: 'edit',
                callback_url: undefined,
                execution_expires_after: undefined,
                priority: undefined,
                return_last_frame: undefined,
                safety_identifiernew: undefined,
            };
        },
    },
    'seedance-2.0-beijing': {
        apiKeyEnv: 'VOLCENGINE_API_KEY_BEIJING',
        enableTranslation: false,
        enableAigcMaterialReview: true,
        aigcMaterialChannel: 'beijing',
        buildInput: (params) => {
            const { prompt, imagePrompt, videoUri, videoUris, audioUri, audioUris, aspectRatio, duration, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage, lastImage] = extractImageFrames(imagePrompt);
            const images = (imagePrompt ?? []).filter(Boolean).slice(0, 9);
            const allMedia = [
                ...((videoUris?.length ?? 0) > 0 ? videoUris! : videoUri ? [videoUri] : []).filter(Boolean).map(url => ({ type: 'video' as const, url })),
                ...((audioUris?.length ?? 0) > 0 ? audioUris! : audioUri ? [audioUri] : []).filter(Boolean).map(url => ({ type: 'audio' as const, url })),
            ].slice(0, 3);
            const videos = allMedia.filter(m => m.type === 'video').map(m => m.url);
            const audios = allMedia.filter(m => m.type === 'audio').map(m => m.url);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    model: 'ep-20260305182240-xhgxj',
                    content: [
                        {
                            type: "text",
                            text: prompt
                        },
                        {
                            type: "image_url",
                            image_url: { url: firstImage },
                            role: "first_frame"
                        },
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p', '4k'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                    // 可选参数
                    generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : false,
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                    // system
                    callback_url: undefined,
                    return_last_frame: undefined,
                    execution_expires_after: undefined,
                    safety_identifiernew: undefined,
                    priority: undefined,
                };
            // 首尾帧模式
            } else if (frameMode === 'first_last') {
                return {
                    model: 'ep-20260305182240-xhgxj',
                    content: [
                        {
                            type: "text",
                            text: prompt
                        },
                        {
                            type: "image_url",
                            image_url: { url: firstImage },
                            role: "first_frame"
                        },
                        {
                            type: "image_url",
                            image_url: { url: lastImage || firstImage },
                            role: "last_frame"
                        },
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p', '4k'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                    // 可选参数
                    generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : false,
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                    // system
                    callback_url: undefined,
                    return_last_frame: undefined,
                    execution_expires_after: undefined,
                    safety_identifiernew: undefined,
                    priority: undefined,
                };
            // 参考模式
            } else if (frameMode === 'ref') {
                return {
                    model: 'ep-20260305182240-xhgxj',
                    content: [
                        {
                            type: "text",
                            text: prompt
                        },
                        ...images.map(url => ({
                            type: "image_url",
                            image_url: { "url": url },
                            role: "reference_image"
                        })),
                        ...videos.map(url => ({
                            type: "video_url",
                            video_url: { "url": url },
                            role: "reference_video"
                        })),
                        ...audios.map(url => ({
                            type: "audio_url",
                            audio_url: { "url": url },
                            role: "reference_audio"
                        })),
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p', '4k'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                    // 可选参数
                    generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : false,
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                    // system
                    callback_url: undefined,
                    return_last_frame: undefined,
                    execution_expires_after: undefined,
                    safety_identifiernew: undefined,
                    priority: undefined,
                };
            // 文生视频模式
            } else {
                return {
                    model: 'ep-20260305182240-xhgxj',
                    content: [
                        {
                            type: "text",
                            text: prompt,
                        }
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p', '4k'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                    // 可选参数
                    generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : false,
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                    // system
                    callback_url: undefined,
                    return_last_frame: undefined,
                    execution_expires_after: undefined,
                    safety_identifiernew: undefined,
                    priority: undefined,
                };
            }
        },
    },
};

// 样片模式：与 2.5 同一接入点，请求固定 draft=true 且只出 480p
seedance2BeijingConfigs['seedance-2.5-api-draft-beijing'] = withDraft480p(
    seedance2BeijingConfigs['seedance-2.5-api-beijing'],
);

// 正式渠道同时承接样片转正式（providerOptions._draftTask）
seedance2BeijingConfigs['seedance-2.5-api-beijing'] = withDraftTask(seedance2BeijingConfigs['seedance-2.5-api-beijing']);